export default {
  'salesCategory.title': 'Sales Category',
  'salesCategory.selectPlaceholder': 'more details',
  'salesCategory.salesCategoryIsBrokenDownInto': 'Sales Category is broken down into',
  'salesCategory.edit.title': 'Edit Sales Category',
  'salesCategory.create.title': 'Create Sales Category',

  'salesCategory.field.name': 'Name',
  'salesCategory.field.foreign_name': 'Foreign Name',
  'salesCategory.field.description': 'Description',
  'salesCategory.field.foreign_description': 'Foreign Description',

  'salesCategory.column.name': 'Sales Category',
  'salesCategory.column.itemName': 'Sales Category > Item Name',
  'salesCategory.column.orderSourceAndServiceType': 'Sales Category > Order Source & Service Type',
  'salesCategory.column.serviceTypeAndOrderSource': 'Sales Category > Service Type & Order Source',
  'salesCategory.column.server': 'Sales Category > Server',
  'salesCategory.column.operation': 'Action',

  'salesCategory.column.sales_category': 'Name',
  'salesCategory.column.item_qty': 'Item Qty',
  'salesCategory.column.net_sales_column': 'Net Sales',
  'salesCategory.column.discount_amount': 'Discount Amount',
  'salesCategory.column.tax_amount': 'Tax Amount',
  'salesCategory.column.gross_sales_column': 'Gross Sales',

  'salesCategory.name.isRequired': 'Name is Required',
  'salesCategory.foreign_name.isRequired': 'Foreign Name is Required',

  'salesCategory.deletion.promptContent': 'Sure to delete the Sales category?',
};
